/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import React, { useCallback, useContext,useState, useEffect } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { OrganizationService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import metadata from './TWIAEmailComponent.metadata.json5';
import messages from '../../addressMessages.messages';

function TWIAEmailComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { accountHolderVM, updateSubmissionVM, authHeader, showErrors, findInvalidComponent, onValidate, companyType, ceUserName, autoPayEnabled, emailValidationMessages: emailAddValidationMsgs,
         setEmailAddValidationMsgs, setValidatingEmail
     } = props;
    const [accountVM, updateAccountVM] = useState(accountHolderVM);
    const [emailValidationMessages, setEmailValidationMessage] = useState([]);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TWIAEmailComponent');
    const emailAddress = _.get(accountHolderVM, 'emailAddress1');
    const isEmailRequired = emailAddress && emailAddress?.aspects?.required;

    const validateEmail = useCallback((event ,fullValue) => {
        const { model, value } = fullValue;
        setEmailValidationMessage([]);
        setEmailAddValidationMsgs([]);
        _.set(accountVM, 'emailAddress1NotProducerEmail_TWIA.value', true);
        if (value && authHeader) {
            try{
                OrganizationService.isProducerEmail_TWIA(value, authHeader).then(
                    (response) => {
                        if (response) {
                            setEmailValidationMessage([translator(messages.TWIAProducerEmailError)]);
                             _.set(accountVM, 'emailAddress1NotProducerEmail_TWIA.value', false);
                            
                        } else {
                            setValidatingEmail?.(false);
                        }
                        updateSubmissionVM(accountVM);
                    }
                ) 
            }catch(err){
                console.error(err);
                setValidatingEmail?.(false);
            }
        }

        if (!value && (!_.isNil(ceUserName) || autoPayEnabled)) {

            setEmailValidationMessage([translator(messages.required)])
        } else if (value && emailAddress && !emailAddress.aspects.valid) {
            setEmailValidationMessage([translator(messages.emailValidationMessage)])
        }

        updateSubmissionVM(accountVM);
    }, [emailAddress]);
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAEmailComponent');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TWIAEmailComponent');
    }, [findInvalidComponent, isComponentValid])
    
    const writeValue = useCallback(
        (value, path) => {
            _.set(accountVM, path, value);
            updateSubmissionVM(accountVM);
            setValidatingEmail?.(true);
        }, [accountVM, updateSubmissionVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        email:{
            onBlur: validateEmail,
            validationMessages:  !_.isEmpty(emailAddValidationMsgs) ? emailAddValidationMsgs : emailValidationMessages,
            visible: companyType === "twia",
            showRequired: !_.isNil(ceUserName) || autoPayEnabled || isEmailRequired,
            required: !_.isNil(ceUserName) || autoPayEnabled || isEmailRequired,
        },
        emailTFPA:{ //DE16358
            onBlur: validateEmail,
            // validator: { 
            //     pattern: "(^[a-zA-Z0-9_.]+[@]{1}[a-z0-9]+[.][a-z]+$)",
            //     message: "Must be a valid email address.",
            // },
            validationMessages:  !_.isEmpty(emailAddValidationMsgs) ? emailAddValidationMsgs : emailValidationMessages,
            visible: companyType === "tfpa",
            showRequired: true,
            required: true,
        },
    }
    const resolvers = {
        resolveClassNameMap: wizardStyles,
    }

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={accountHolderVM}
                overrideProps={overrideProps}
                onModelChange={updateAccountVM}
                onValueChange={writeValue}
                onValidationChange={setComponentValidation}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
        />
    )
}

TWIAEmailComponent.propTypes = {
    autoPayEnabled: PropTypes.bool,
    emailAddValidationMsgs: PropTypes.shape([]),
    setEmailAddValidationMsgs: PropTypes.func
};

TWIAEmailComponent.defaultProps = {
    autoPayEnabled: false,
    emailAddValidationMsgs: [],
    setEmailAddValidationMsgs: () => {}

};

export default TWIAEmailComponent